<template>
  <section class="section">
    <div class="container no-print">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            Data Analysis/ DASM ລາຍງານຜະລິດຕາມສັນຍາ
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab">
        <b-tab-item label="ລາຍງານຜະລິດຕາມສັນຍາ ທັງໝົດ">
          <div class="columns">
            <div class="column">
              <b-field label="ລາຍງານຜະລິດຕາມສັນຍາ ທັງໝົດ">
                <table width="100%" class="table ">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">
                        #
                      </th>
                      <th class="has-text-centered " width="50%">
                        ແຂວງ (B2B)
                      </th>
                      <th class="has-text-centered " width="30%">
                        ຈຳນວນສັນຍາ
                      </th>
                      <th class="has-text-centered " width="30%">
                        ຈຳນວນສິນຄ້າ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in reportDetailList"
                      :key="data.ID"
                    >
                      <td class="has-text-centered">
                        {{ index + 1 }}
                      </td>
                      <td class="has-text-centered">
                        {{ data.PROVINCENAME }}
                      </td>
                      <td class="has-text-centered">
                        {{ data.NUMOFCONTRACT }}
                      </td>
                      <td class="has-text-centered">
                        {{ data.NUMOFPRODUCT }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
          <br />
          <br />
          <div style="font-size: 14px;">
            ໝາຍເຫດ: <br />
            - ຈຳນວນສັນຍາແມ່ນ ສັນຍາທີ່ສົ່ງໄປຜະລິດ<br />
            - ຈຳນວນສິນຄ້າ ແມ່ນສິນຄ້າທີ່ສົ່ງໄປຜະລິດ
          </div>
        </b-tab-item>
        <b-tab-item label="ລາຍງານ ທຽບໃສ່ ແຜນປະຈຳປີ">
          <div class="columns">
            <div class="column">
              <b-field label="ເລືອກປີ">
                <Multiselect
                  placeholder="ເລືອກ"
                  v-model.trim="selectedYear"
                  label="YEAR"
                  track-by="YEAR"
                  :options="yearList"
                  @input="onSelectedYear"
                >
                </Multiselect>
              </b-field>
            </div>
            <div class="column"></div>
            <div class="column"></div>
            <div class="column"></div>
            <div class="column"></div>
          </div>
          <div class="columns">
            <div class="column">
              <b-field :label="compareLabel">
                <table width="100%" class="table ">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">
                        #
                      </th>
                      <th class="has-text-centered " width="50%">
                        ແຂວງ (B2B)
                      </th>
                      <th class="has-text-centered " width="30%">
                        ຈຳນວນສັນຍາ<br />
                        ແຜນ : ລາຍງານ
                      </th>
                      <th class="has-text-centered " width="30%">
                        ຈຳນວນສິນຄ້າ<br />
                        ແຜນ : ລາຍງານ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in compareList" :key="data.ID">
                      <td class="has-text-centered">
                        {{ index + 1 }}
                      </td>
                      <td class="has-text-centered">
                        {{ data.PROVINCENAME }}
                      </td>
                      <td class="has-text-centered">
                        <span
                          v-if="
                            data.NUMOFCONTRACT / data.NUMOFCONTRACT_PLAN >= 1
                          "
                          class="statusLabel-passed"
                        >
                          {{ data.NUMOFCONTRACT_PLAN }} :
                          {{ data.NUMOFCONTRACT }} =
                          {{
                            (
                              (data.NUMOFCONTRACT / data.NUMOFCONTRACT_PLAN) *
                              100
                            ).toFixed(2)
                          }}%
                        </span>

                        <span
                          v-else-if="
                            data.NUMOFCONTRACT / data.NUMOFCONTRACT_PLAN >= 0.5
                          "
                          class="statusLabel-yellow"
                        >
                          {{ data.NUMOFCONTRACT_PLAN }} :
                          {{ data.NUMOFCONTRACT }} =
                          {{
                            (
                              (data.NUMOFCONTRACT / data.NUMOFCONTRACT_PLAN) *
                              100
                            ).toFixed(2)
                          }}%
                        </span>

                        <span
                          v-else-if="
                            data.NUMOFCONTRACT / data.NUMOFCONTRACT_PLAN >= 0.1
                          "
                          class="statusLabel-organge"
                        >
                          {{ data.NUMOFCONTRACT_PLAN }} :
                          {{ data.NUMOFCONTRACT }} =
                          {{
                            (
                              (data.NUMOFCONTRACT / data.NUMOFCONTRACT_PLAN) *
                              100
                            ).toFixed(2)
                          }}%
                        </span>

                        <span
                          v-else-if="
                            data.NUMOFCONTRACT / data.NUMOFCONTRACT_PLAN >= 0
                          "
                          class="statusLabel-black"
                        >
                          {{ data.NUMOFCONTRACT_PLAN }} :
                          {{ data.NUMOFCONTRACT }} =
                          {{
                            (
                              (data.NUMOFCONTRACT / data.NUMOFCONTRACT_PLAN) *
                              100
                            ).toFixed(2)
                          }}%
                        </span>
                      </td>
                      <td class="has-text-centered">
                        <span
                          v-if="data.NUMOFPRODUCT / data.NUMOFPRODUCT_PLAN >= 1"
                          class="statusLabel-passed"
                        >
                          {{ data.NUMOFPRODUCT_PLAN }} :
                          {{ data.NUMOFPRODUCT }} =
                          {{
                            (
                              (data.NUMOFPRODUCT / data.NUMOFPRODUCT_PLAN) *
                              100
                            ).toFixed(2)
                          }}%
                        </span>

                        <span
                          v-else-if="
                            data.NUMOFPRODUCT / data.NUMOFPRODUCT_PLAN >= 0.5
                          "
                          class="statusLabel-yellow"
                        >
                          {{ data.NUMOFPRODUCT_PLAN }} :
                          {{ data.NUMOFPRODUCT }} =
                          {{
                            (
                              (data.NUMOFPRODUCT / data.NUMOFPRODUCT_PLAN) *
                              100
                            ).toFixed(2)
                          }}%
                        </span>

                        <span
                          v-else-if="
                            data.NUMOFPRODUCT / data.NUMOFPRODUCT_PLAN >= 0.1
                          "
                          class="statusLabel-organge"
                        >
                          {{ data.NUMOFPRODUCT_PLAN }} :
                          {{ data.NUMOFPRODUCT }} =
                          {{
                            (
                              (data.NUMOFPRODUCT / data.NUMOFPRODUCT_PLAN) *
                              100
                            ).toFixed(2)
                          }}%
                        </span>

                        <span
                          v-else-if="
                            data.NUMOFPRODUCT / data.NUMOFPRODUCT_PLAN >= 0
                          "
                          class="statusLabel-black"
                        >
                          {{ data.NUMOFPRODUCT_PLAN }} :
                          {{ data.NUMOFPRODUCT }} =
                          {{
                            (
                              (data.NUMOFPRODUCT / data.NUMOFPRODUCT_PLAN) *
                              100
                            ).toFixed(2)
                          }}%
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
          <br />
          <br />
          <div style="font-size: 14px;">
            ໝາຍເຫດ: <br />
            - ຈຳນວນສັນຍາແມ່ນ ສັນຍາທີ່ສົ່ງໄປຜະລິດ<br />
            - ຈຳນວນສິນຄ້າ ແມ່ນສິນຄ້າທີ່ສົ່ງໄປຜະລິດ
          </div>
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import moment from "moment";
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect },
  data() {
    return {
      userName: null,
      roleid: null,
      activeTab: 1,

      reportDetailList: [],
      compareList: [],
      yearList: [],
      selectedYear: null,

      currentDate: null,
      currentYear: null,
      compareLabel: null,
    };
  },
  methods: {
    onSelectedYear() {
      this.currentYear = this.selectedYear.YEAR;
      this.getdasmReport();
      this.activeTab = 1;
    },
    getdasmReport() {
      if (this.currentYear == null) {
        this.currentDate = new Date();
        this.currentYear = this.currentDate.getUTCFullYear();
      }

      this.compareLabel = "ລາຍງານ ທຽບໃສ່ ແຜນປະຈຳປີ " + this.currentYear;

      console.log("currentYear:" + this.currentYear);

      RestAPI.dasmReport(this.currentYear, this.userBranchID)
        .then((res) => {
          this.reportDetailList = res.data.all;
          this.compareList = res.data.compare;
          this.yearList = res.data.year;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },

    clearPrintdata() {
      this.prepareidforprint = [];
      this.combineorderforprint = [];
      this.combineorderdetailforprint = [];
    },

    printReceipt(prepareid) {
      this.getMarketOnlineOrderDetailbyPrepareid(prepareid);
    },

    print() {
      window.print();
    },
  },
  mounted() {
    // console.log("this.user.BRANCHPROVNICEID: " + JSON.stringify(this.user));
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.userProvinceID = this.user.BRANCHPROVNICEID
      ? this.user.BRANCHPROVNICEID
      : "all";
    this.userBranchID = this.user.DASMBRANCHID ? this.user.DASMBRANCHID : "all";
    this.getdasmReport();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.very-important-title {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 20px;
  margin-top: 40px;
}

/* .paymentdetailselected {
  margin-top: 5px;
  margin-bottom: 5px;
}
.paymentdetailselectedhightlight {
  font-weight: bold;
} */

.print-receipt {
  font-size: 10px;
}
.print-receipt-titel {
  font-size: 12px;
}
.print_table {
  font-size: 10px;
}
.print_tr {
  padding: 0px 0px 0px 0px;
}
.print_td {
  padding: 0px 0px 0px 0px !important;
  margin: 0px 0px 0px 0px !important;
  /* font-size: 20px; */
}
@media all {
  .page-break {
    display: none;
  }
}
@media print {
  @page {
    margin: -10px 0px 0px 0px !important;
    padding: -10px 0px 0px 0px !important;
    size: portrait;
  }
  .page-break {
    display: block;
    max-width: 99%;
  }
}
</style>
